import React, { useMemo } from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const CHIPS = [
  { key: "total",     label: "Total",       color: "#00ff90"  },
  { key: "open",      label: "Open",        color: "#60a5fa"  },
  { key: "pending",   label: "Pending",     color: "#fbbf24"  },
  { key: "escalated", label: "Escalated",   color: "#fb923c"  },
  { key: "p1",        label: "P1 Critical", color: "#f87171"  },
  { key: "breached",  label: "SLA Breached",color: "#f43f5e"  },
];

export default function TicketKpis({ tickets = [], kpis }) {
  const fallback = useMemo(() => ({
    total:     tickets.length,
    open:      tickets.filter(t => t.status === "Open").length,
    pending:   tickets.filter(t => t.status === "Pending").length,
    escalated: tickets.filter(t => t.status === "Escalated").length,
    p1:        tickets.filter(t => t.priority === "P1").length,
    breached:  tickets.filter(t => t.breached).length,
  }), [tickets]);

  const stats = kpis || fallback;

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        {CHIPS.map(({ key, label, color }) => (
          <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            <p className="text-lg font-bold" style={{ color }}>{stats[key] ?? "—"}</p>
            <p className="text-xs text-white/30 mt-0.5">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}